export default __webpack_public_path__ + "static/bg-hero-image-shadow-3437f00ddbe888b8f9f06deb761273f4.png";